<template>
    <pt-dialog
        width="460px"
        v-model="visible"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div :class="$style.auth_dialog">
            <div :class="$style.title">{{ $t('common.app_ver_expire') }}</div>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <pt-button size="medium" @click="handleClick">
                    {{ $t('common.button_refresh') }}
                </pt-button>
            </span>
        </template>
    </pt-dialog>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import useEventBus from '@assets/plugins/eventBus';

export default defineComponent({
    name: 'RefreshApp',
    setup() {
        const { eventBus } = useEventBus();
        const visible = ref(false);

        onMounted(() => {
            eventBus.$on('appVersionExpire', showPopup);
        });
        onUnmounted(() => {
            eventBus.$off('appVersionExpire', showPopup);
        });

        return {
            visible,
            showPopup,
            handleClick
        };
        function showPopup() {
            visible.value = true;
        }
        function handleClick() {
            window.location.reload();
        }
    }
});
</script>

<style lang="scss" module>
@import '@style/import.scss';
.auth_dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: $pt-black-900;
    padding: 0 0 8px;

    .title {
        font-size: 16px;
        line-height: 28px;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }
}
</style>
